import React from "react";
import DashboardContent from "../../components/dashboard-content";
import Header from "../../layouts/Header";
import GradientBackground from "../../layouts/GradientBackground";

export default function Dashboard() {
  return (
    <GradientBackground>
      <Header />
      <DashboardContent />
    </GradientBackground>
  );
}
